import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer";


const ForgetPassword = () => {

    const selectISDRef = useRef(null);
    const mobileRef = useRef(null);
    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    const rePasswordRef = useRef(null);

    const [isdcodes, setISDCode] = useState([]);
    const [selectedISDCode, setSelectedISDCode] = useState('99');
    const [isdSearchTerm, setISDSearchTerm] = useState('');

    const [email, setEmail] = useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [mobile, setMobileNumber] = useState("");
    const [isValidMobile, setIsValidMobile] = useState(true);

    const [isUpdateStatus, setIsUpdateStatus] = useState(false); // New state for Update Status

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [isValidPassword, setIsValidPassword] = useState(true);

    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();


    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        emailRef.current.focus();
        fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-ISDCodeList', setISDCode);
    }, []);

    const handleEmailChange = async (event) => {
        const inputEmail = event.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmail(inputEmail);
        setIsValidEmail(emailRegex.test(inputEmail) || inputEmail === "");

    };

    const handleISDCodeChange = (event) => {
        setSelectedISDCode(event.target.value);
        setMobileNumber("");
    };

    const handleMobileNumberChange = async (event) => {
        const inputMobileNumber = event.target.value;
        const maxLength = selectedISDCode === '99' ? 10 : 11;

        if (/^\d*$/.test(inputMobileNumber) && inputMobileNumber.length <= maxLength) {
            setMobileNumber(inputMobileNumber);
            setIsValidMobile(true);

        } else {
            setIsValidMobile(false);
        }
    };

    const handlePasswordChange = (event) => {
        const newPassword = event.target.value;
        setPassword(newPassword);

        // Validate password and confirm password
        setIsValidPassword(newPassword === confirmPassword);
    };

    const handleConfirmPasswordChange = (event) => {
        const newConfirmPassword = event.target.value;
        setConfirmPassword(newConfirmPassword);

        // Validate password and confirm password
        setIsValidPassword(password === newConfirmPassword);
    };

    const handleKeyPress = (event) => {
        const value = isdSearchTerm + event.key;
        setISDSearchTerm(value);

        const exactMatch = isdcodes.find(code => code.isdCode === value);
        const partialMatch = isdcodes.find(code => code.isdCode.startsWith(value) || code.isdCodeName.toLowerCase().includes(value.toLowerCase()));

        const match = exactMatch || partialMatch;

        if (match) {
            handleISDCodeChange({ target: { value: match.isdCode } });
        }
    };

    const handleResetPassword = async (event) => {
        event.preventDefault();


        if (email.trim() === '') {
            alert("Please enter a valid email address.");
            emailRef.current.focus();
            return;
        }
        if (!isValidEmail) {
            alert('Please enter a valid email address.');
            emailRef.current.focus();
            return;
        }
        if (mobile.trim() === '') {
            alert('Please enter mobile number');
            mobileRef.current.focus();
            return;
        }
        const minLength = selectedISDCode === '99' ? 10 : 8; // Minimum length depends on ISD code
        if (mobile.length !== minLength) {
            alert('Please enter a valid mobile number with the correct number of digits.');
            mobileRef.current.focus();
            return;
        }
        if (!isValidMobile) {
            alert('Please enter a valid mobile number.');
            mobileRef.current.focus();
            return;
        }
        if (password === '') {
            alert("Please enter a password.");
            passwordRef.current.focus()
            return;
        }
        if (confirmPassword === '') {
            alert("Please enter password again.");
            rePasswordRef.current.focus()
            return;
        }
        if (password !== confirmPassword) {
            setIsValidPassword(false);
            rePasswordRef.current.focus();
            return;
        }
        const resetdata = {
            email: email,
            ISDCode: selectedISDCode,
            mobile: mobile,
            password: password
        };

        // Validate input before triggering the API call
        if (!email || !mobile || !password || !confirmPassword) {
            setErrorMessage("Please enter both user ID and password.");
            return;
        }

        const response = await fetch('https://igapi.heuristticminds.com/api/UsersList/Update-ResetPassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(resetdata), // Replace with your data
        });
        // Clear previous error message
        setErrorMessage("");

        if (response.ok) {
            const result = await response.json();
            setIsUpdateStatus(result.isUpdateStatus);
            if (result.isUpdateStatus) {
                alert("Password sent to your registered email. Please check and login.");
                navigate('/login');
            } else {
                setErrorMessage("Invalid User Credentials");
            }

        } else {
            setErrorMessage("InValid User 2");
        }

    };

    return (
        <>
            <Header />
            <div className="bg-light p-4" style={{ marginTop: '110px' }}>
                <div className="col-sm-8 m-auto">
                    <div className="row no-gutters shadow-lg">
                        <div className="col-md-5 d-none d-md-block p-0">
                            <img src="images/login-bg.jpg" className="img-fluid h-100" alt="Login Background" />
                        </div>
                        <div className="col-md-7 bg-white p-5">
                            <h4 className="text-center">Reset Password</h4>
                            <div className="form_style">
                                <form>

                                    <div className="row_input">
                                        <span className="lbl1">Email Address</span>
                                        <input
                                            type="email"
                                            value={email}
                                            ref={emailRef}
                                            onInput={handleEmailChange}
                                            placeholder="Enter Email"
                                            className="txt1"
                                            id="txtEmail"
                                            aria-describedby="emailHelp"
                                            tabIndex={1}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <div className="row_input me-3" style={{ width: 150 }}>
                                            <span className="lbl1">ISD Code</span>

                                            <select
                                                id="selectedISDCode"
                                                ref={selectISDRef}
                                                value={selectedISDCode}
                                                name="selectedISDCode"
                                                className="txt1"
                                                onChange={handleISDCodeChange}
                                                tabIndex={2}
                                                onKeyDown={handleKeyPress}
                                            >
                                                <option value="0">--ISD--</option>
                                                {isdcodes.map((code) => (
                                                    <option key={code.isdCode} value={code.isdCode}>
                                                        {code.isdCodeName}
                                                    </option>
                                                ))}

                                            </select>
                                        </div>
                                        <div className="row_input">
                                            <span className="lbl1">Mobile Number</span>
                                            <input
                                                type="text"
                                                value={mobile}
                                                onInput={handleMobileNumberChange}
                                                id="mobileNumber"
                                                tabIndex={3}
                                                ref={mobileRef}
                                                placeholder="Enter mobile number"
                                                className={`txt1`}
                                                autoComplete="off"
                                                aria-describedby="emailHelp"
                                                onChange={(e) => setMobileNumber(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="row_input">
                                        <span className="lbl1">New Password</span>
                                        <input
                                            type="password"
                                            value={password}
                                            onInput={handlePasswordChange}
                                            id="password"
                                            tabIndex={4}
                                            maxLength={20}
                                            ref={passwordRef}
                                            placeholder="Enter Password"
                                            className="txt1"
                                            autoComplete="off"
                                            onChange={(e) => setPassword(e.target.value)}

                                        />
                                    </div>
                                    <div className="row_input">
                                        <span className="lbl1">Re-Enter Password</span>
                                        <input
                                            type="password"
                                            value={confirmPassword}
                                            onInput={handleConfirmPasswordChange}
                                            id="confirmPassword"
                                            tabIndex={5}
                                            maxLength={20}
                                            ref={rePasswordRef}
                                            placeholder="Re-Enter Password"
                                            //className="txt1"
                                            className={`txt1 ${isValidPassword ? "" : "is-invalid"}`}
                                            autoComplete="off"
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    handleResetPassword(e);
                                                }
                                            }
                                            }
                                        />
                                    </div>
                                    <div className="pb-2">
                                        <button
                                            type="submit"
                                            className="btn btn-dark w-100 font-weight-bold mt-2 p-2 rounded-1"
                                            onClick={handleResetPassword}
                                            tabIndex={6}
                                        >
                                            Reset
                                        </button>
                                    </div>
                                    {errorMessage && <div className="text-danger">{errorMessage}</div>}
                                </form>
                                <div className="pt-2 text-center">
                                    <Link className="btn btn-link" to="/login">Go to Login</Link>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )


}
export default ForgetPassword;